import { render, staticRenderFns } from "./CostBasedConfiguration.vue?vue&type=template&id=3afcf973&scoped=true&"
import script from "./CostBasedConfiguration.vue?vue&type=script&lang=js&"
export * from "./CostBasedConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afcf973",
  null
  
)

export default component.exports